// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// SUB ENTRY POINT SCHEMA
/////////////////////////////////////////

export const SubEntryPointSchema = z.object({
  method: z.string(),
  routePath: z.string().nullable(),
  params: z.string().nullable(),
  description: z.string(),
  codeSnippet: z.string(),
  endpointId: z.string().nullable(),
  aiComponentId: z.string().nullable(),
  reachable: z.boolean().nullable(),
  graphqlOperationName: z.string().nullable(),
  soapOperationName: z.string().nullable(),
})

export type SubEntryPoint = z.infer<typeof SubEntryPointSchema>

export default SubEntryPointSchema;
